
import { Link } from 'react-router-dom';
import styles from './breadcrumb.module.css';

const BreadCrumb = ({ items }) => {
    return (<>
        <ul className={styles.breadcrumbList}>
            {items.map((item, index) => (<ListItem key={index} index={index} item={item} length={items.length} />))}
        </ul>
    </>);
}

const ListItem = ({ item, index, length }) => {
    return (<li><Link to={item.url}>{item.title}</Link>{index !== length - 1 ? <i className={'fa fa-angle-left'} /> : null}</li>)
}

export default BreadCrumb;